'use strict';

import {SocketConnector} from '../support_connectors/base_connector/socket_connector';

/**
 * WBGSessionConnector class
 * allow polling and socket reconnection after session refresh
 * 
 * @inheritDoc
 */
    
export default class WBGSessionConnector extends SocketConnector {

    constructor(socket) {
        super(socket);
        this.verbose_name = "WBGSessionConnector:";
        this.controller_id = "session-rpc";
        this.timerId = null;
        
        this.socket.on("startPolling", ({period, url}) => {
            this.__doPoll(url);
            this.__startPolling(period, url);
        });    
    }
    
    __startPolling(period,url) {      
        if(this.timerId)
            clearInterval(this.timerId)

        this.timerId = setInterval( () => this.__doPoll(url),  period);        
    }        


    __doPoll(url) {
        $.ajax({
            url: url,
            success: (result) => {
                this.__log("poll success", result);
            },
            statusCode: {
                200: () => { //  "Session not need refresh"
                    this.__log(200, "Session not need refresh");
                },
                202: () => { //Session refresh
                    this.__log(202, "Session refresh");
                    this.__SocketReconect();
                },
                403: () => { //session not found
                    this.__log("session not found");
                    this.__SocketReconect();
                }
            }
        });
    }

    __SocketReconect() {
        this.socket.close();
        this.socket.open();
    }

}


// WEBPACK FOOTER //
// ./src/library/minigame_client/common/WBGSessionConnector.es6